import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { customPadding } from '../../../utils/styled-functions';

const RecentWorkSkeletonGroupedHeading = (): React.JSX.Element => {
	return (
		<GroupingHeader>
			<Skeleton isShimmering width={50} height={8} />
		</GroupingHeader>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const GroupingHeader = styled.div`
	padding-left: ${token('space.100', '8px')};
	padding-bottom: ${token('space.150', '12px')};
	${(props) => customPadding(props.theme.groupedListHeaderPadding)}
`;

export default RecentWorkSkeletonGroupedHeading;
